import { ParsedState, Token } from '@/components/ui/TokenizedInput/types';

// NOTE: whitespace is preserved as much as possible during (de)serialization to allow for natural input behaviour

interface TokenGroups {
  field: string;
  operation: string;
  value: string;
  remainder: string;
}
const tokenPattern =
  /^\s*(?<field>\w+)\s+(?<operation>\w+):\s*"(?<value>[^"]*)"(?<remainder>.*)$/;

interface PartialTokenGroups {
  field: string;
  operation: string;
  value: string;
}

const partialPattern = /^(?<field>\w+)\s+(?<operation>\w+):(?<value>[^"]*)$/;

export function serialize(state: ParsedState): string {
  const tokenStrings = state.tokens
    .map((token) => `${token.field} ${token.operation}: "${token.value}"`)
    .join(' ');

  const last = state.partial
    ? `${state.partial.field} ${state.partial.operation}:${state.partial.value}`
    : state.remainder;

  return tokenStrings + last;
}

export function deserialize(input: string): ParsedState {
  return parseTokens(input);
}

function parseTokens(input: string, tokens: Token[] = []): ParsedState {
  if (!input.trim()) {
    return { tokens, partial: null, remainder: input };
  }

  // try match complete token
  const match = input.match(tokenPattern);
  if (!match) {
    // try match partial token
    const partialMatch = input.match(partialPattern);
    if (!partialMatch) {
      // return as remainder
      return {
        tokens,
        partial: null,
        remainder: input,
      };
    }

    const { field, operation, value } =
      partialMatch.groups as unknown as PartialTokenGroups;
    return {
      tokens,
      partial: { field, operation, value },
      remainder: null,
    };
  }

  const { field, operation, value, remainder } =
    match.groups as unknown as TokenGroups;

  const token = {
    field,
    operation,
    value,
  };

  return parseTokens(remainder, [...tokens, token]);
}
